// extracted by mini-css-extract-plugin
export default {"avatar":"r8BS4","donate":"FugUq","become-supporter-container":"HSUqB","become-supporter-header":"u5mXl","become-supporter-paragraph":"a7vNR","become-supporter-text":"f_Uhr"};